module.exports = __webpack_public_path__ + "img/core_memories.14bc0808.jpg";